<div class="flex flex-col h-screen bg-background">
  <header class="shrink-0 border-b border-border px-10 py-3 flex items-center gap-8">
    <a routerLink="/dashboard/rf-wizard"><img src="icons/blue-owl-horizontal.svg" alt="Blue Owl" class="h-9" width="174" height="36" fetchpriority="high" /></a>
    <app-header-nav-menu />
    <div class="ml-auto flex items-center gap-3">
      <app-notification-bell />
      <app-user-avatar />
    </div>
  </header>

  <main class="flex-1 min-h-0 overflow-y-auto px-10 pt-10 pb-4">
    <router-outlet />
  </main>

  <app-toast-outlet />
</div>
